<template>
	<div style="padding-left: 20px; padding-right: 20px">
		<div v-if="contestConfiguration.emptyOfferHint">
			<h2 style="margin-left: 20px">Podgląd formularza oferty</h2>
			<div style="margin-left: 20px; margin-top: 20px; margin-bottom: 20px; white-space: pre-wrap">{{
				contestConfiguration.emptyOfferHint }}
			</div>
		</div>
		<ContestOfferMainDataEmpty
					:readonly="true"
					:contest-configuration="contestConfiguration"
					:contest-id="contestData.id"
					:title="''"
					:english-title="''"
					:priorities-data="{extraCountries: [], selected: [], mainCountryId: null}"
					:other-bidders-id="[]"
					:mutual-offer="false"
					ref="contestOfferMainData"
		></ContestOfferMainDataEmpty>
		<ContestOfferStatsEmpty
					:readonly="true"
					:contest-id="contestData.id"
					:finances-data="{}"
					:priorities-data="{extraCountries: [], selected: [], mainCountryId: null}"
					:dac-codes-enabled="contestConfiguration.dacCodesEnabled"
					:dac-codes="[]"
					ref="stats"
		></ContestOfferStatsEmpty>
		<ChooseStartEnd
					:readonly="true"
		></ChooseStartEnd>
		<ChooseActionsEmpty
					:contest-id="contestData.id"
					:actions-data="[]"
					:min-start="null"
					:max-end="null"
					:taken-serial-numbers="{}"
					:module-id="0"
					:number-of-modules="1"
					:module-number="1"
					:readonly="true"
		></ChooseActionsEmpty>
		<ChooseGeographicalLocationsEmpty
					:readonly="true"
		></ChooseGeographicalLocationsEmpty>
		<CostsTableEmpty
					:taken-serial-numbers="{}"
					:offer-configuration="contestConfiguration"
					:module-number="1"
					:readonly="true"
		></CostsTableEmpty>	
		<CostsSummaryTableEmpty style="margin-top: 20px"
					:offer-configuration="contestConfiguration"
					:main-country-id="{}"
					:main-bidder-id="{}"
					:contest-id="contestData.id"
					:number-of-modules="1"
					:module-number="1"
					:offer-data-id="1"
					ref="costsSummary"
		></CostsSummaryTableEmpty>	
		<BidderFundingsTableEmpty style="margin-top: 20px"
					:number-of-modules="1"
					:module-number="1"
					:readonly="false"
				></BidderFundingsTableEmpty>
		<div v-if="contestConfiguration.moduleSchema">
			<div v-for="(section, index) in moduleGenericMap()" v-bind:key="index+100">
				<h2 >{{contestConfiguration.moduleSchema.sections[index].name}}</h2>
				<vue-form-generator
					:disabled="true"
					:name="'generator-'.concat(index)"
					:model="section.model"
					:schema="section.schema"
				/>
			</div>
		</div>
		<div v-for="(section, index) in persistentGenericMap" v-bind:key="index">
			<h2 style="margin-left: 20px">{{contestConfiguration.persistentSchema.sections[index].name}} </h2>
			<vue-form-generator
				:disabled="true"
				:name="'persistentGenerator-'.concat(index)"
				:model="section.model"
				:schema="section.schema"
			/>
		</div>
	</div>
</template>
<script>
	import Vue from "vue";
	import {genericFormUtil} from "../../../utils/genericFormUtil";
	import VueFormGenerator from "vue-form-generator";
	import {Api} from "../../../api";
	import ContestOfferMainDataEmpty from "@/view/landing_page/components/ContestOfferMainDataEmpty";
	import ContestOfferStatsEmpty from "@/view/landing_page/components/ContestOfferStatsEmpty";
	import ChooseStartEnd from "@/view/logged/offer/components/ChooseStartEnd";
	import ChooseActionsEmpty from "@/view/landing_page/components/ChooseActionsEmpty";
	import ChooseGeographicalLocationsEmpty from "@/view/landing_page/components/ChooseGeographicalLocationsEmpty";
	import CostsTableEmpty from "@/view/landing_page/components/CostsTableEmpty";
	import CostsSummaryTableEmpty from "@/view/landing_page/components/CostsSummaryTableEmpty";
	import BidderFundingsTableEmpty from "@/view/landing_page/components/BidderFundingsTableEmpty";



	Vue.use(VueFormGenerator);


	export default {
		name: "EmptyOfferView",
		components: {ContestOfferMainDataEmpty, ContestOfferStatsEmpty, ChooseStartEnd, ChooseActionsEmpty, ChooseGeographicalLocationsEmpty, CostsTableEmpty, CostsSummaryTableEmpty, BidderFundingsTableEmpty},

		computed: {

			persistentGenericMap () {
				if (this.contestConfiguration.persistentSchema === null || this.offerData.genericModel === null) {
					return null;
				} else {
					let sectionsArray = [];

					for (let i = 0; i < this.contestConfiguration.persistentSchema.sections.length; i++) {
						if (!genericFormUtil.sectionShouldNotBeOnView(this.contestConfiguration.persistentSchema, i)) {
							sectionsArray.push(
								{
									schema: this.applyGenericPersistentForm(i),
									model: this.offerData.genericModel.sections[i].fields,
								},
							);
						}
					}
					return sectionsArray;
				}
			},
		},

		data () {
			return {

				contestData: {
					id: this.$route.params.contestId,
				},

				// tutaj pakujemy dane z konfiguracji konkursu
				contestConfiguration: {
					numberOfModules: 0,
					moduleSchema: null,
					persistentSchema: null,
					emptyOfferHint: null
				},

				// tutaj pakujemy dane oferty
				offerData: {
					moduleGenericModel: undefined,
					genericModel: undefined,
				},

				formGenerator: {
					currentSchema: {},
					currentModel: {},
					formOptions: {
						validateAfterLoad: false,
						validateAfterChanged: true,
						validateAsync: true,
					},
					currentConditionalBooleans: [],
				},
			};
		}
		,

		created () {
			this.loadData();
			window.scrollTo(0, 0);
		}
		,

		methods: {

			async loadData () {
				await Api.syncGet(this, "/public-contest/empty-offer?contestId=".concat(this.contestData.id), response => {
					// inicjalizuje schematy generycznego formularza
					if (response.emptyOfferHint) {
						this.contestConfiguration.emptyOfferHint = response.emptyOfferHint;
					}
					this.initializeContestConfiguration(response);
					// inicjalizujemy wartosci generycznego formularza w ofercie
					this.contestConfigurationLoaded = true;
					this.initializeGenericModel();
					this.offerDataLoaded = true;
				},
				);
			},

			moduleGenericMap () {
				let sectionsArray = [];
				for (let i = 0; i < this.contestConfiguration.moduleSchema.sections.length; i++) {
					sectionsArray.push(
						{
							schema: this.applyGenericModuleForm(i),
							model: this.applyGenericModuleForm(i),
						});
				}
				return sectionsArray;
			},
			initializeContestConfiguration (response) {
				if (response.contestSchemaSet && response.contestSchemaSet.moduleSchema) {
					this.contestConfiguration.moduleSchema = genericFormUtil.decodeSchema(response.contestSchemaSet.moduleSchema);
				}
				if (response.contestSchemaSet && response.contestSchemaSet.offerSchema) {
					this.contestConfiguration.persistentSchema = genericFormUtil.decodeSchema(response.contestSchemaSet.offerSchema);
				}
				// this.contestConfiguration.persistentSchema = genericFormUtil.decodeSchema(response.persistentSchema);
				this.contestConfiguration.volunteersAvailable = response.volunteersAvailable;
				this.contestConfiguration.volunteerLimit = response.volunteerLimit;
				this.contestConfiguration.minDaysAbroad = response.minDaysAbroad;
				this.contestConfiguration.manyAreas = response.manyAreas;
				this.contestConfiguration.manyPriorities = response.manyPriorities;
				this.contestConfiguration.manyTasks = response.manyTasks;
				this.contestConfiguration.manyAccreditationCountries = response.manyAccreditationCountries;
				this.contestConfiguration.volunteersRequired = response.volunteersRequired;
				this.contestConfiguration.financialTableHint = response.financialTableHint;
				this.contestConfiguration.name = response.name;
				this.contestConfiguration.shortName = response.shortName;
				this.contestConfiguration.dacCodesEnabled = response.dacCodesEnabled;

			},

			initializeGenericModel () {
				this.offerData.genericModel = this.getPersistentModel();
				this.offerData.moduleGenericModel = this.getModuleModel();
			}
			,

			getModuleModel () {
				if (this.contestConfiguration.moduleSchema) {
					return genericFormUtil.buildModelFromSchema(this.contestConfiguration.moduleSchema);
				}
			}
			,


			getPersistentModel () {
				if (this.contestConfiguration.persistentSchema) {
					return genericFormUtil.buildModelFromSchema(this.contestConfiguration.persistentSchema);
				}
			}
			,

			initializeGenericSchemas (response) {
				this.contestConfiguration.persistentSchema = this.getPersistentSchema(response);
				this.contestConfiguration.moduleSchema = this.getModuleSchema(response);
			}
			,

			getModuleSchema (response) {
				if (response.moduleSchema) {
					return genericFormUtil.decodeSchema(response.moduleSchema);
				}
				return null;
			}
			,

			getPersistentSchema (response) {
				return genericFormUtil.decodeSchema(response.persistentSchema);
			}
			,
			enableAttachmentLinks (schema) {
				if (schema && schema.groups) {
					schema.groups.forEach(group => {
						group.fields = group.fields.map(field => {
							if (field.type === 'customAttachment' && field.link) {
								return Object.assign({}, field, { disabled: false });
							}
							return field;
						});
					});
				}
				return schema;
			},

			applyGenericPersistentForm (sectionIndex) {
				let sections = this.offerData.genericModel.sections;
				let schema = genericFormUtil.getSectionSchemaFromSchema(this.contestConfiguration.persistentSchema, sectionIndex, true);
				if (genericFormUtil.sectionSchemaContainsConditionalField(schema)) {
					schema = genericFormUtil.filterSchemaByConditionalFieldsValue(schema, sections[sectionIndex].fields);
				}
				return this.enableAttachmentLinks(schema);
			},

			applyGenericModuleForm (sectionIndex) {
				let sections = this.offerData.moduleGenericModel.sections;
				let schema = genericFormUtil.getSectionSchemaFromSchema(this.contestConfiguration.moduleSchema, sectionIndex, true);
				if (genericFormUtil.sectionSchemaContainsConditionalField(schema)) {
					schema = genericFormUtil.filterSchemaByConditionalFieldsValue(schema, sections[sectionIndex].fields);
				}
				return this.enableAttachmentLinks(schema);
			},
		},
	};
</script>
<style scoped>
</style>
